import { createSelector } from 'reselect'

export const getCancelTicketIn24hsState = state => state.cancelTicketIn24hs

export const isFetchingCancelTicketIn24hs = createSelector(getCancelTicketIn24hsState, refundState =>
  refundState ? refundState.isFetching : null
)
export const getCancelTicketIn24hsError = createSelector(getCancelTicketIn24hsState, refundState =>
  refundState ? refundState.error : null
)
export const getCancelTicketIn24hsSuccess = createSelector(getCancelTicketIn24hsState, refundState =>
  refundState ? refundState.data : null
)
